import React from 'react';

import API from 'utils/api';

import { UuidableName } from 'utils/api/types';

import { Container, NotAnswered, UserCellName, UserCellNameContainer, UserCellAvatar } from './styles';
import { UserProps } from './types';

const GridUserRenderer: React.FunctionComponent<UserProps> = ({ value }) => {
  const [user, setUser] = React.useState<UuidableName | null | undefined>(undefined);

  React.useEffect(() => {
    let isCancelled = false;

    const loadUser = async (): Promise<void> => {
      // If value is null or undefined, set user to null
      if (!value) {
        setUser(null);
        return;
      }

      // If value is already a UuidableName object, use it directly
      if (typeof value === 'object' && 'uuid' in value && 'name' in value) {
        setUser(value);
        return;
      }

      // Otherwise, value is a string (userId) - fetch user data
      if (typeof value === 'string') {
        setUser(undefined);
        try {
          const { data } = await API.user.loadUserData(value)();
          if (!isCancelled) {
            setUser(data);
          }
        } catch (error) {
          if (!isCancelled) {
            setUser(null);
          }
        }
      }
    };

    loadUser();

    return () => {
      isCancelled = true;
    };
  }, [value]);

  if (user === null) {
    return <NotAnswered>N/A</NotAnswered>;
  }

  if (user === undefined) {
    return <>Loading...</>;
  }

  return (
    <Container>
      {user.name && <UserCellAvatar name={user.name} size="small" />}
      <UserCellNameContainer>
        <UserCellName>{user.name}</UserCellName>
      </UserCellNameContainer>
    </Container>
  );
};

export default GridUserRenderer;
